import { InsuredDO } from './';
export class GroupEAppUIDO {

    private id: Number;

    //owner
    public ownerGuid: any = null;
    public ownerId: any = null;
    public ownerNameCd: any = null;
    public ownerGenderCd: any = null;
    public ownerDOB: any = null;  
    public ownerRole = "OWNER";
    public ownerCompanyName: any = null;
    public ownerContactPeronName: any = null;  
    public ownerAddressList = [];
    public ownerContactList = [];
    public ownerEmailList = [];
    public ownerIdentityList = [];

    public ownerType: any = null;
    public ownerOrganisationName:any=null;
    public ownerContactPersonName:any=null;

    //payer
    public payerGuid: any = null;
    public payerId: any = null;
    public payerNameCd: any = null;
    public payerGenderCd: any = null;
    public payerDOB: any = null;
    public sourceOfIncomeCd: any = null;
    public paymentMethodCd: any = null;
    public paymentFrequencyCd: any = null;
    public payerAccountNumberCd: any = null;
    public accountHolderNameCd: any = null;
    public payerRole = "PAYER"
    public payerAddressList = [];
    public payerContactList = [];
    public payerEmailList = [];
    public payerIdentityList = [];
    public payerOccupationList = [];
    public payerType: any = null;
    public companyName: any = null;
    public contactPeronName: any = null;
    
    public bankName: any = null;
    public bankAddress: any = null;
    
    public payerOrganisationName:any=null;
    public payerContactPersonName:any=null;

    //coverage
    public policyStartDate: any = null;
    public policyExpiryDate: any = null;
    public term: number = null;

    public discount: any = 0;

    public selectedProduct: any = null;
    public selectedPlan: any = null;

    //insuredDO
    public insuredMembers: InsuredDO[] = [];

    public questionsList: any = [];
    public isEditMode = null;
    public isUIDO = true;

    public package:any=null;
    //client address do
    //client contact do
    //client email do
    //entity do
    //person do
    //policy beneficiary do
    //PersonEmploymentDO
    //PersonIdentityDO
    //ClientDO
    //PolicyCoverage
    //PolicyDO

}